var utils = require('f.component.util');

var Player = require('../flash');

var win = window;
var doc = document;

var Core = function(options, isStream) {
    //console.log(options);
    this.init(options, isStream);
};

Core.prototype = {
    init: function(options, isStream) {
        this.options = options;
        this.isStream = isStream;
        this.createModel();
        this.transParams();
        this.resolveTemplate();
        this.createPlayer();
    },

    renderTo: function(parentNode) {
        this.flash = $(this.el).children()[0];
        parentNode.append($(this.el).children()[0]);
        // console.log(this.flash);
    },

    createModel: function() {
        if (this.isStream) {
            //如果是直播
            this.swfId = 'js_streamVideo' + this.options.listId;
        } else {
            this.swfId = 'js_playVideo' + this.options.listId;
        }
    },
    transParams: function() {
        var transKeys = [{ key: 'autoPlay', value: 'AutoPlay' }];

        for (var i = 0, iLen = transKeys.length; i < iLen; i++) {
            if (transKeys[i].key in this.options) {
                this.options[transKeys[i].value] = this.options[transKeys[i].key];
            }
        }
    },

    resolveTemplate: function() {
        this.el = document.createElement('div');
    },

    createPlayer: function() {
        var key;
        var conf = this.options.conf;
        var param = this.options.paramConf;
        var varConf = this.options.varConf;
        // debugger;
        var player = new Player(this.el, {
            url: conf.swfUrl,
            height: conf.height,
            width: conf.width,
            id: this.swfId,
        });

        for (key in param) {
            player.addParam(key, param[key]);
        }

        for (key in varConf) {
            player.addVariable(key, varConf[key]);
        }

        player.play();
        this.player = player;
        player.addCallback('swfplay', videoEnd);
        player.addCallback('goPage', goPage);
    },

    danmuSend: function(data) {
        this.flash.danmuSend(data);
    },

    play: function() {
        this.flash.videoPlay();
    },

    pause: function() {
        this.flash.videoPause();
    },

    show: function() {
        $(this.flash).show();
    },

    hide: function() {
        $(this.flash).hide();
    },

    destroy: function() {
        $(this.flash).remove();
    },
};

var videoEnd = function() {
    return 'the last!';
};

var goPage = function(url) {
    window.open(url);
};

module.exports = Core;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.video.pc/app/modules/core/index.js